export default class ActionRequest {
  constructor(obj) {
    if (!obj) obj = {};
    this.email = obj.email ? obj.email : "";
    this.actionId = obj.actionId ? obj.actionId : 0;
  }
}
